import dayjs from 'dayjs'
import getItemStyles from '../../../utils/item-styles.js';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';
import timelineDisplayOrder from './timelineDisplayOrder.js';

/**
 * Returns a formatted day off item for the one to two day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTimeRequest = (resource, dayType) => {
  const { rId } = resource;
  const { dayOffRequest } = dayType;
  const { dorId, abbreviation, dayOffRequestTitle, startTime, endTime, dayTypeComment, myDayTypeComment,isApproved,wbse,showCostObjectId,costCenter } = dayOffRequest;
  let hasComment = false;
  if (myDayTypeComment) {
    hasComment = true;
  }
  const offtimeStyle = getItemStyles('dayOffRequest');  // TODO: update
  const momentStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
  const offsetTime = 0;
  const offsetStartTime = dayjs(momentStartTime).add(offsetTime, 'minute');
  const offsetEndTime = dayjs(dayjs.unix(endTime).utc().format("YYYY-MM-DD HH:mm:ss"));
  const offTimeRequest = {
    id: dorId,
    itemType: 'off-request',
    group: rId,
    dorId,
    title: dayOffRequestTitle || `Days off request: ${abbreviation}`,  // postedSched || liveSched
    start_time: offsetStartTime.startOf('day'),
    end_time: offsetEndTime.endOf('day'), // Note: using 'offsetEndTime.startOf' causes dayOffRequests to have 0 duration and barely be visible
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: offtimeStyle.backgroundColor,
    color: offtimeStyle.color,
    borderStyle: offtimeStyle.borderStyle,
    borderColor: hasComment ? "red" : offtimeStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.dayOffRequest,
    isApproved,
    wbse,
    showCostObjectId,
    costCenter
  };
  return offTimeRequest;
}

export default generateOffTimeRequest;
